"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _spacing = require("../styles/spacing");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n\n  dt {\n    font-size: ", ";\n    color: ", ";\n    line-height: 1.5;\n  }\n\n  dd {\n    ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DescriptionList = _styledComponents.default.dl.withConfig({
  displayName: "UIDescriptionList__DescriptionList",
  componentId: "sc-1csbavn-0"
})(_templateObject(), (0, _spacing.margin)('y', 0), _sizes.MICROCOPY_SIZE, _colors.SLINKY, (0, _spacing.margin)('left', 0), (0, _spacing.margin)('bottom', 3)); // eslint-disable-next-line react/prop-types


var UIDescriptionList = function UIDescriptionList(_ref) {
  var __as = _ref.as,
      props = (0, _objectWithoutProperties2.default)(_ref, ["as"]);
  return _react.default.createElement(DescriptionList, props);
};

UIDescriptionList.displayName = 'UIDescriptionList';
UIDescriptionList.propTypes = {
  children: _propTypes.default.node
};
var _default = UIDescriptionList;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/list/UIDescriptionList.js
// module id = 283
// module chunks = 209 210 211 212